import H6 from '@base/H6/H6';
import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import pushRoute from '@utils/pushRoute';
import { useRouter } from 'next/router';
import Typography from 'aquilla/core/atoms/Typography';
import AquillaButton from 'aquilla/core/molecules/Button';
import StoreCard from './StoreCard';

const MyPurchaseWrapper = styled.div`
  margin-top: ${Spacings.SPACING_10B};
  margin-bottom: ${Spacings.SPACING_11B};
  width: 848px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${Spacings.SPACING_8B};
  column-gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    width: 100%;
    margin-bottom: ${Spacings.SPACING_6B};
    margin-top: ${Spacings.SPACING_6B};
    gap: ${Spacings.SPACING_4B};
  }
`;

const StoreCardWrapper = styled.div`
  width: 272px;
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const MyPurchaseHeading = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Title = styled(Typography)`
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H5};
  }
`;

const SeeAllCta = styled(H6)`
  color: var(--color-i-green);
  cursor: pointer;
`;

const SeeAllPurchase = styled(AquillaButton)<{
  inGoalPage?: boolean;
}>`
  border: ${(props) =>
    props.inGoalPage ? 'none' : '1px solid var(--color-i-black)'};
  color: ${(props) =>
    props.inGoalPage ? 'var(--color-i-green)' : 'var(--color-i-black)'};
  width: 100%;
  ${(props) =>
    props.inGoalPage &&
    `
      padding-top: 12px;
      padding-bottom: 12px;
    `}
`;

const SeeAllWrapper = styled.div`
  width: 100%;
  margin-top: ${Spacings.SPACING_2B};
`;

const PurchasedBlock = ({ className, data: skuData }) => {
  const isMobile = useIsMobile();
  const { pathname } = useRouter();

  const redirectToSettings = () => {
    const path = '/settings';
    pushRoute(path, path);
  };
  const inGoalPage = pathname === '/goal/[goalSlug]/[goalUID]';
  const purchaseDetail = () => {};

  return (
    <MyPurchaseWrapper className={className} onClick={purchaseDetail}>
      <MyPurchaseHeading>
        <Title variant="h4">My purchases</Title>
        {!isMobile && (
          <SeeAllCta onClick={redirectToSettings}>SEE ALL</SeeAllCta>
        )}
      </MyPurchaseHeading>
      {skuData.map((courseInfo) => (
        <StoreCardWrapper key={courseInfo}>
          <StoreCard data={courseInfo} includeCta />
        </StoreCardWrapper>
      ))}
      {isMobile && (
        <SeeAllWrapper className="SeeAll-btn-wrapper">
          <SeeAllPurchase
            className="seeAll-btn"
            inGoalPage={inGoalPage}
            variant={inGoalPage ? 'ghost-green' : 'secondary'}
            size="large"
            onClick={redirectToSettings}
          >
            See all
          </SeeAllPurchase>
        </SeeAllWrapper>
      )}
    </MyPurchaseWrapper>
  );
};

export default PurchasedBlock;
